/**
 * Options type for the boolean formatter function
 */
export type BooleanFormatterOptions = {
  /**
   * The text to display for true values
   * @default "True"
   */
  trueLabel?: string;
  /**
   * The text to display for false values
   * @default "False"
   */
  falseLabel?: string;
};

/**
 * Helper function for formatting table cells with boolean values
 * @param value - The boolean value to format
 * @param options - The options for the boolean formatter
 * @returns The formatted boolean label or null for undefined/null values
 */
export const booleanFormatter = (
  value?: boolean | null,
  { trueLabel = "True", falseLabel = "False" }: BooleanFormatterOptions = {},
) => {
  if (value == null) {
    return null;
  }
  return value ? trueLabel : falseLabel;
};
